import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Secure } from '../../../api/api-checkout/models/rq-checkout-booking';
import { GlobalComponent } from '../../../shared/global';
import { FlightDataService } from './flight-data.service';
import { INSURANCE_PRICE } from '../../../shared/constants';

@Injectable({
  providedIn: 'root',
})
export class BookingInsuranceService {
  private readonly insurance = new BehaviorSubject<Secure | undefined>(undefined);
  insurance$ = this.insurance.asObservable();

  constructor(private readonly flightDataService: FlightDataService) {}

  getValue() {
    return this.insurance.getValue();
  }

  setValue(value: Secure | undefined) {
    this.insurance.next(value);
  }

  addInsurance() {
    const itinerary = this.flightDataService.getValue();
    if (itinerary) {
      const unitPrice = INSURANCE_PRICE;
      const totalPrice = itinerary.passengersQty * itinerary.totalDays * unitPrice;
      const moneyExchange = GlobalComponent.appExchangeRate.amount;
      const insurance: Secure = {
        unitPrice,
        totalPrice,
        moneyExchange,
        isDomestic: itinerary.isDomestic,
      };
      this.setValue(insurance);
    }
  }
}
